import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorPresenter } from '../presenter';

export const ServerErrorPresenter: React.VFC<{
  showNavigator?: boolean;
}> = ({ showNavigator = false }) => {
  const { t } = useTranslation();
  return (
    <ErrorPresenter
      title={t('ui.pages.Error.ServerError.title')}
      message={t('ui.pages.Error.ServerError.message')}
      showNavigator={showNavigator}
    />
  );
};
